module.exports = __webpack_public_path__ + "static/media/02.9ac26ae9.jpg";